var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "-2 -3.5 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin",
    className: "jam jam-vimeo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.129.849C18.646.323 17.946.042 17.05.016c-2.53-.083-4.319 1.277-5.317 4.04a.413.413 0 0 0 .083.42.401.401 0 0 0 .405.118c.288-.08.572-.12.847-.12.369 0 .86.068 1.103.394.188.25.213.626.076 1.116-.115.413-.711 1.52-1.449 2.69-.898 1.427-1.394 2.067-1.537 2.067-.474 0-2.187-7.673-2.234-7.842C8.535 1.141 8.289.26 6.69.26 5.474.258 2.758 2.504.528 4.461l-.342.299a.54.54 0 0 0-.074.736l.415.54a.526.526 0 0 0 .727.109l.023-.017C2 5.611 2.68 5.121 3.195 5.094c.559-.027 1.044.855 1.622 2.955 1.102 4.078 2.775 8.94 4.493 8.94 1.794 0 3.935-1.538 6.703-5.176 2.505-3.294 3.846-5.905 3.933-7.806.064-1.435-.21-2.498-.817-3.158z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/vi.cc82b826c2192fefaf17c7b7c4bba30c.svg";
export { ForwardRef as ReactComponent };